import { Box } from '@mui/system'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInput from 'components/custom/AdxInput'
import { differenceInDays, format } from 'date-fns'
import React, { useState } from 'react'
import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { saveAppraisal } from 'services/api/modules/performance/appraisal/appraisal'
import EvaluationSnackBar from '../../appraisal-company-mgmt/components/EvaluationSnackBar'
import ManageHeader from '../components/ManageHeader'
import UpdateDatePicker from '../components/UpdateDatePicker/UpdateDatePicker'

const ManageAppraisal = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state

  const [appraisalTitle, setAppraisalTitle] = useState(state.label)
  const [appraisalDescription, setAppraisalDescription] = useState(state.description)
  const [date, setDate] = useState({ startDate: state.start_date, endDate: state.due_date })
  const [getError, setGetError] = useState()
  const [showError, setShowError] = useState(false)
  const [specialError, setSpecialError] = useState('')

  // To check if date is changed
  const [dateChanged, setDateChanged] = useState(false)

  const cycleDate = (start, end) => {
    setDate({ startDate: start, endDate: end })
  }

  const {
    isLoading: saveLoading,
    error: saveError,
    mutate: saveMutate,
  } = useMutation((values) => saveAppraisal(state.id, values), {
    onSuccess: async () => {
      // alert("success!")
      setDateChanged(false)
      navigate(`/app/appraisal-cycle/details/${state.id}`, { state: { ...state } })
    },
    onError: async (error) => {
      setSpecialError(
        error?.data?.message ===
          'The chosen start and due date overlap with existing appraisal cycles'
          ? error?.data?.message
          : null
      )
      if (Object.keys(error?.data?.errors).length > 1) {
        setGetError(Object.values('You have incomplete fields'))
      } else {
        setGetError('You have an incomplete field')
      }
      setShowError(true)
    },
  })
  const handleUpdateAppraisal = () => {
    let newAppraisal = {}
    dateChanged
      ? (newAppraisal = {
          label: appraisalTitle,
          description: appraisalDescription,
          start_date: format(date.startDate, `yyyy/MM/dd`),
          due_date: format(date.endDate, `yyyy/MM/dd`),
        })
      : (newAppraisal = {
          label: appraisalTitle,
          description: appraisalDescription,
        })

    saveMutate(newAppraisal)
  }
  return (
    <>
      <EvaluationSnackBar
        message={getError}
        status={'error'}
        autoHideDuration={4000}
        showError={showError}
        setShowError={setShowError}
      />
      <Box
        sx={{
          backgroundColor: 'gray-background.main',
          minHeight: '100vh',
          maxWidth: '100vw',
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <ManageHeader
          headerTitle="Manage Appraisal"
          appraisalTitle={appraisalTitle}
          handleUpdate={handleUpdateAppraisal}
        />
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          gap={2}
          sx={{
            backgroundColor: 'white.main',
            width: '67%',
            borderRadius: '4.5px',
            boxShadow: '0px 0px 10px lightgray',
            my: 10,
            p: 3,
          }}
        >
          <AdxInput
            label="Cycle name"
            size="standard"
            placeholder="E.g January 2021"
            charLimit={50}
            value={appraisalTitle}
            onChange={(i) => {
              setAppraisalTitle(i.target.value)
            }}
            isErrorShown={saveError?.data?.errors?.label}
            errorMessage={<AdxErrorMessage children={saveError?.data?.errors?.label} />}
          />
          <AdxInput
            label="Description (optional)"
            type="large"
            placeholder="Type here"
            charLimit={500}
            multiline
            sxInput={{
              padding: 2,
              height: '300px',
              display: 'flex',
              alignItems: 'flex-start',
              overflowY: 'scroll',
            }}
            value={appraisalDescription}
            onChange={(i) => setAppraisalDescription(i.target.value)}
          />
          <UpdateDatePicker
            label="Period"
            cycleDate={cycleDate}
            setDateChanged={setDateChanged}
            values={{
              startDate: Date.parse(state.start_date),
              endDate: Date.parse(state.due_date),
              duration:
                differenceInDays(Date.parse(state.due_date), Date.parse(state.start_date)) + 1,
            }}
            isErrorShown={specialError || saveError?.data?.errors?.due_date}
            errorMessage={
              saveError?.data?.errors?.due_date ? (
                <AdxErrorMessage children={saveError?.data?.errors?.due_date} />
              ) : (
                <AdxErrorMessage children={specialError} />
              )
            }
          />
        </Box>
      </Box>
    </>
  )
}

export default ManageAppraisal
